import IsServerSideRendering from './IsServerSideRendering';

const tradesSummaryRegex = /^(\/trades)$/;

const isOnTradesSummary = () => {
  if (IsServerSideRendering) return null;

  const urlPath = window.location.pathname;
  return urlPath.match(tradesSummaryRegex);
};

export default isOnTradesSummary;
